import React from 'react';
import { Link } from 'react-router-dom'
import why_work from '../../../assets/images/why-work.png';
import { Navigate } from 'react-router-dom';
import CustomModalView from '../../../common/input/customModal/customModalView';
import DatePicker from '../../../common/input/date-picker/DatePicker';
import moment from 'moment'


const ScheduleInterviewView = (props) => {
    const yesterday = moment().subtract(1, 'day');
    const disablePastDt = current => {
      return current.isAfter(yesterday);
    };
     
        return (
            <>
                <section className="login-wrapper">
                    <div className="container">
                        <div className="row" >
                            <div className="col-lg-6 login-center">
                                <div className="login-form-main">
                                    <div className="registration-form_wrapper">
                                        <div className="content">
                                            <img src={why_work} alt="" />
                                            <h3>carerconnect</h3>
                                            <h4>Whenever Wherever</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 login-center">
                                <div className="invitation-form" style={{width:'auto'}}>
                                    <h3>Schedule Your Interview</h3>
                                    <form>
                                        <div className="input-icons">
                                             <i class="fa fa-clock-o icon" style={{borderRight: '1px solid #8cd52e',paddingTop: '16px',paddingLeft: '23px'}}></i>
                                             <div id="job-datepicker" className="input-group date datetime-noborder" data-date-format="yyyy-mm-dd">
                                                <DatePicker
                                                    minValue={"today"}
                                                    className="form-control"
                                                    placeholder="Select the date"
                                                    handleLangChange = {(date) => props.handleLangChange('start_date',date)}
                                                />
                                            </div>
                                        </div>
                                        <div className="input-icons">
                                            <i class="fa fa-clock-o icon"  style={{borderRight: '1px solid #8cd52e',paddingTop: '16px',paddingLeft: '23px'}}></i>
                                            <input placeholder="12:00 AM" value={props.time === ""? "00:00": props.time} id="time-picker" onFocus={(e)=>e.target.type='time'} onBlur={(e)=> {if(e.target.value==''){e.target.type='text'}}} onChange={(e) => props.handelData('time', e.target.value,props.index)} className="form-control input-field" style={{borderRadius: '29px', height: '50px'}}  /> 
                                        </div>
                                        <div className="field-box login-form">
                                            <button type="button" onClick={props.handelSummit}>Submit <i className="fa fa-sign-in "></i></button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <CustomModalView
                    modal_show={props.modal_show}
                    authResponse = {props.authResponse}
                    showCustomModal= {props.showCustomModal}
                    hideCustomModal={props.hideCustomModal}
                    custom_model = {props.custom_model}
                    />
            </>
        )

}

export default ScheduleInterviewView;